import { FC, useContext } from "react";
import "./TaskDetails.css"
import { TaskContext } from "../../../../contexts/TaskContext";
import { dateToNiceString } from "../../../../helpers/dateToNiceString";

const TaskDetails: FC = () => {
    const taskContext = useContext(TaskContext);

    return (
        <div className='task-details-component'>
            <div className='task-details-body'>
                <div className='task-details-body-row'>
                    <a className='task-details-body-row-head'>
                        Дата создания:
                    </a>
                    <a className='task-details-body-row-value'>
                        {taskContext.taskInformation?.createdAt
                            ? dateToNiceString(new Date(taskContext.taskInformation.createdAt), "dd.MM.yy hh:mm")
                            : "-"
                        }
                    </a>
                </div>
                <div className='task-details-body-row'>
                    <a className='task-details-body-row-head'>
                        Дата изменения:
                    </a>
                    <a className='task-details-body-row-value'>
                        {taskContext.taskInformation?.updatedAt
                            ? dateToNiceString(new Date(taskContext.taskInformation.updatedAt), "dd.MM.yy hh:mm")
                            : "-"
                        }
                    </a>
                </div>
            </div>
        </div>
    );
};

export default TaskDetails;